import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { images } from '../../constants';
import { contactInfo } from '../../data';
import './contactus.scss';

const API_URL = process.env.REACT_APP_API_URL || '';

const Contactus = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.name || !formData.email || !formData.message) {
      setStatus({ type: 'error', message: t('contact.errorRequired') });
      return;
    }

    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({ type: 'success', message: t('contact.successMessage') });
        setFormData({ name: '', phone: '', email: '', message: '' });
      } else {
        setStatus({ type: 'error', message: data.error || t('contact.errorGeneric') });
      }
    } catch (error) {
      setStatus({ type: 'error', message: t('contact.errorGeneric') });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="Contact__top">
        <h1>{t('contact.title')}</h1>
        <p>{t('contact.subtitle')}</p>
      </div>

      <div className="Contact__collection container section">

        <div className="Contact__infocollection">
          <div className="Contact__info-section">
            <img className="Contact__img" src={images.location} alt="" />
            <img className="Contact__blur" src={images.bgBlur} alt="" />
            <h2>{t('contact.visitUs')}</h2>
            <p>{contactInfo.address}</p>
          </div>

          <div className="Contact__info-section">
            <img className="Contact__img" src={images.mail} alt="" />
            <img className="Contact__blur" src={images.bgBlur} alt="" />
            <h2>{t('contact.sendEmail')}</h2>
            <p>{contactInfo.email}</p>
          </div>

          <div className="Contact__info-section">
            <img className="Contact__img" src={images.phone} alt="" />
            <img className="Contact__blur" src={images.bgBlur} alt="" />
            <h2>{t('contact.makeCall')}</h2>
            <p>{contactInfo.phone}</p>
          </div>

        </div>

        <div className="Contact__form">
          <form onSubmit={handleSubmit}>
            <h2>{t('contact.formTitle')}</h2>
            <input
              className="Contact__name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder={t('contact.namePlaceholder')}
              disabled={isSubmitting}
            />
            <input
              className="Contact__no"
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder={t('contact.phonePlaceholder')}
              disabled={isSubmitting}
            />
            <input
              className="Contact__email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={t('contact.emailPlaceholder')}
              disabled={isSubmitting}
            />
            <textarea
              className="Contact__msg"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder={t('contact.messagePlaceholder')}
              disabled={isSubmitting}
            />

            {status.message && (
              <p className={`Contact__status Contact__status--${status.type}`}>
                {status.message}
              </p>
            )}

            <button className="Contact__send" type="submit" disabled={isSubmitting}>
              <h2>{isSubmitting ? t('contact.sending') : t('contact.sendButton')}</h2>
              <img src={images.arrowRight} alt="" />
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Contactus;
